import { DynamicTilesetService } from './dynamic-tileset.service';
import { MapService } from './map.service';
import { PolygonSelectionService } from './polygon-selection-service';
import { SharedMapService } from './shared-map.service';

export const services = [
  MapService,
  DynamicTilesetService,
  PolygonSelectionService,
  SharedMapService
];
